import { render, staticRenderFns } from "./Pendencias.vue?vue&type=template&id=55dbaae6&scoped=true"
import script from "./Pendencias.vue?vue&type=script&lang=js"
export * from "./Pendencias.vue?vue&type=script&lang=js"
import style0 from "./Pendencias.vue?vue&type=style&index=0&id=55dbaae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dbaae6",
  null
  
)

export default component.exports